import React, { Component } from 'react';
import englishResources from 'wix-rich-content-common/dist/statics/viewer/locale/messages_en.json';
import { withI18n } from 'wix-rich-content-common';
import ContentViewer from './ContentViewer.js';
import 'classnames';
import '../rtl.rtlignore-24db3a02.js';
import './ContentTraverser.js';
import './rericos/renderers/index.js';
import 'ricos-schema';
import './rericos/renderers/paragraph/paragraph.js';
import 'ricos-context';
import '../alignment.rtlignore-281a8e5e.js';
import '../indentation-67ed6b13.js';
import './rericos/renderers/consts.js';
import './rericos/utils/Anchorable.js';
import './rericos/utils/paywallSeo.js';
import './rericos/renderers/blockquote/blockquote.js';
import 'ricos-converters';
import './rericos/renderers/codeblock/codeblock.js';
import './rericos/renderers/heading/heading.js';
import './rericos/renderers/lists/bulletedList.js';
import '../lists-0ca42744.js';
import './rericos/renderers/lists/orderedList.js';
import './rericos/renderers/lists/listItem.js';
import './rericos/renderers/text/text.js';
import './rericos/decorators/index.js';
import 'ricos-common-plugins/viewer';
import './rericos/decorators/nodeViewDecorators.js';
import './rericos/renderers/plugins/getPluginRenderers.js';
import './rericos/renderers/plugins/fromExternalNode.js';
import 'ricos-content/libs/struct-converters';
import '../getClassNames-a0522f4d.js';
import 'lodash';
import './rericos/renderers/plugins/nodeViewContainer.js';
import './rericos/renderers/plugins/ContainerElement.js';
import './components/ErrorBoundary.js';
import './RicosNodesRenderer.js';
import './rericos/render.js';
import './components/Anchor.js';
import './rericos/utils/SpoilerManager.js';
import './components/AddAnchors.js';
import 'ricos-styles';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const WrappedViewer = withI18n(
  ContentViewer,
  englishResources,
  { forceRemount: false }
);
class I18nRichContentViewer extends Component {
  render() {
    return /* @__PURE__ */ React.createElement(WrappedViewer, __spreadValues({ key: "I18NViewer" }, this.props));
  }
}
I18nRichContentViewer.displayName = "ContentViewer";

export { I18nRichContentViewer as default };
//# sourceMappingURL=I18nRicosContentViewer.js.map
